/**
 * Erreur métier renvoyée par une Cloud Function.
 *
 * Le client ne rejoue aucune règle métier : il se contente de traduire un code en
 * message. Le catalogue de codes est le contrat partagé avec `functions/src/errors.js`.
 */
export const ERROR_CODES = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  MISSING_PREREQUISITE: 'MISSING_PREREQUISITE',
  LIMIT_REACHED: 'LIMIT_REACHED',
  INVALID_STATE: 'INVALID_STATE',
  CONFLICT: 'CONFLICT',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  INTERNAL: 'INTERNAL',
}

/** Message par défaut si la fonction n'en fournit pas un plus précis. */
const DEFAULT_MESSAGES = {
  [ERROR_CODES.UNAUTHENTICATED]: 'Vous devez être connecté pour effectuer cette action.',
  [ERROR_CODES.FORBIDDEN]: 'Vous n\'avez pas les droits nécessaires pour effectuer cette action.',
  [ERROR_CODES.NOT_FOUND]: 'La ressource demandée est introuvable.',
  [ERROR_CODES.INVALID_ARGUMENT]: 'Les informations transmises sont invalides.',
  [ERROR_CODES.INSUFFICIENT_FUNDS]: 'Trésorerie insuffisante pour cette opération.',
  [ERROR_CODES.MISSING_PREREQUISITE]: 'Un prérequis n\'est pas rempli.',
  [ERROR_CODES.LIMIT_REACHED]: 'La limite autorisée est atteinte.',
  [ERROR_CODES.INVALID_STATE]: 'Cette action n\'est pas possible dans l\'état actuel.',
  [ERROR_CODES.CONFLICT]: 'Cette donnée a été modifiée entre-temps, veuillez réessayer.',
  [ERROR_CODES.ALREADY_EXISTS]: 'Cette donnée existe déjà.',
  [ERROR_CODES.INTERNAL]: 'Une erreur inattendue est survenue.',
}

export default class BusinessError extends Error {
  constructor(code, message, details = null) {
    const finalCode = ERROR_CODES[code] ? code : ERROR_CODES.INTERNAL
    super(message || DEFAULT_MESSAGES[finalCode])
    this.name = 'BusinessError'
    this.code = finalCode
    this.details = details
  }

  /** Construit une erreur métier à partir d'une erreur `httpsCallable`. */
  static fromCallableError(error) {
    const payload = error && error.details ? error.details : null
    const code = payload && payload.code ? payload.code : ERROR_CODES.INTERNAL
    const details = payload && payload.details !== undefined ? payload.details : null
    return new BusinessError(code, error ? error.message : null, details)
  }

  is(code) {
    return this.code === code
  }
}
